const appConfig = {
  // dev mode to mock async data for instance
  DEV_MODE: false,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,

  appName: 'PayVibe SuperAdmin',
  helloWord: 'Hello',
  currentView: 'home',

  // connection status text references
  connectionStatus: {
    online: 'online',
    disconnected: 'disconnected'
  },
  // eaningGraph config
  earningGraph: {
    data: {
      API: 'api/earnigGraphData'
    }
  },
  teamMates:{
    data: {
      API: 'api/teamMates'
    }
  },

  // userInfos config
  userInfos: {
    data: {
      // API: 'http://192.168.1.15:8081/v1/login'
      // API: 'api/userInfos'
    }
  },

  app:{
    port: '3025',
     ip: '192.168.1.16'
    // ip: '0.0.0.0'
    //ip: 'localhost'
  },

  site: {
    siteId: 1,
    secret_key: '0RvyXOymzXXMQi5GLjlQnfBH37Urs2LC9N7xIfDT',
    // siteurl :'https://superadmin.payvibe.com'
    // secret_key: '0rpLyQfWQpngNBeOOipBY2ImJJ0H3RjwR6dykfIz',
    siteurl :''
  },

  api: {
    // url: 'https://ddb-api.dealopia.com/v1/',
    //url: 'http://127.0.0.1:8000/v1/',
    // url: 'http://127.0.0.1:8000/v1/',
    // url: 'https://ddb-api.dealopia.com/v1/',
    //  url: 'https://api.payvibe.com/v1/',
    // url: 'http://127.0.0.1:8000/v1/',
  //url: 'https://api.payvibe.com/v1/',
  //url: 'http://api-payvibe2023.stpi.com/v1/',
	 //url: 'http://apistaging.stpi.com/v1/',
    url: 'https://payvibe-apiv2.dealopia.com/v1/'
    
  },
  admin: {
    // url: 'http://192.168.1.173:3022/',  //Local
    url: "https://admin.payvibe.com/", //Live
	//  url: 'http://superadmin-staging.stpi.com/#/home/',  //Live
    // url: 'http://ddb-site-panel.dealopia.com/', //Staging
    // url: 'http://localhost:3023/',  //Local
    // url: 'http://localhost:3023/',  //Local
    // url: 'http://localhost:3023/',  //Local
  }  

  
};

module.exports = appConfig;



//////////////////
// WEBPACK FOOTER
// ./appConfig.js
// module id = 674
// module chunks = 0